import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { type Money } from "@src/appV2/lib/Money/types";
import { compact } from "lodash";

interface UseGetAutoBookGuaranteedRateParams {
  agentQualifications: string[];
  agentMetropolitanStatisticalArea: string;
}

interface UseGetAutoBookGuaranteedRateResult {
  autoBookRateIsSupported: boolean;
  guaranteedRate?: Money;
}

export function useGetAutoBookGuaranteedRate(
  params: UseGetAutoBookGuaranteedRateParams
): UseGetAutoBookGuaranteedRateResult {
  const { agentQualifications, agentMetropolitanStatisticalArea } = params;

  const autoBookGuaranteedRateVariation = useCbhFlag(CbhFeatureFlag.AUTO_BOOK_GUARANTEED_RATE, {
    defaultValue: {},
  });

  const ratesForAgent = compact(
    agentQualifications.map(
      (agentQualification) =>
        autoBookGuaranteedRateVariation[agentMetropolitanStatisticalArea]?.[agentQualification]
    )
  );

  if (ratesForAgent.length === 0) {
    return {
      autoBookRateIsSupported: false,
    };
  }

  return {
    autoBookRateIsSupported: true,
    guaranteedRate: {
      amountInMinorUnits: Math.max(...ratesForAgent),
      currencyCode: "USD",
    },
  };
}
